import React from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'

import './styles.scss'

const CreateAccountProgressbar = ({ progress }) => {
	const isCreated = progress > 99

	return (
		<div className="create-account-progressbar-container">
			<div className="create-account-progressbar">
				<CircularProgressbar
					maxValue={100}
					minValue={0}
					value={progress - 1}
					strokeWidth={2}
					text={<tspan>{!isCreated ? progress + '%' : '✓'}</tspan>}
					className={isCreated ? 'done' : ''}
				/>
				<span
					className={`progressbar-text ${
						isCreated ? 'progressbar-text--green' : ''
					}`}
				>
					{!isCreated ? 'Creating your account...' : 'Account created'}
				</span>
			</div>
		</div>
	)
}

export { CreateAccountProgressbar }
